import { useState } from "react";
import { Table, Dropdown, Input, Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Translate } from "../../translate";
import Filter from "./Filter";
import DateTime from "../DateTime";
import { getStore, setStore } from "../../utils/global";
import axios from "../../utils/axios";
import Loading from "../Loading";
import { useHistory } from "react-router-dom";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import CancelModal from "./CancelModal";

const ManageRouter = () => {
  const { filter } = useParams();
  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");
  const user = getStore("user");
  const [page, setPage] = useState(1);
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [sortDir, setSortDir] = useState("descend");
  const [namefilter, setNamefilter] = useState("");

  const { data: docCounts = { total: 0, received: 0, archived: 0, complete: 0, rejected: 0, sent: 0, cancelled: 0, waiting: 0 } } = useQuery({
    queryKey: ["get_user_doc_count", user.kdss_user],
    queryFn: () => axios.post("client/api/doc/home", { begin_date: new Date("2019-01-01"), end_date: new Date() }),
    select: ({ data }) => data.count,
  });

  const filters = [
    {
      key: 0,
      filter: "all",
      title: "All",
      icon: "check-circle",
      color: "green",
      href: "#/manage/0/0/0",
    },
    {
      key: 1,
      filter: "received",
      title: "Received",
      icon: "inbox",
      color: "orange",
      href: "#/manage/1/0/0",
    },
    {
      key: 2,
      filter: "archived",
      title: "Archived",
      icon: "archive",
      color: "#ed3755",
      href: "#/manage/2/0/0",
    },
    {
      key: 3,
      filter: "complete",
      title: "Completed",
      icon: "check-square",
      color: "#968fff",
      href: "#/manage/3/0/0",
    },
    {
      key: 4,
      filter: "rejected",
      title: "Rejected",
      icon: "window-close",
      color: "#8444F5",
      href: "#/manage/4/0/0",
    },
    {
      key: 5,
      filter: "sent",
      title: "Sent",
      icon: "paper-plane",
      color: "#39A2DB",
      href: "#/manage/5/0/0",
    },
    {
      key: 6,
      filter: "cancelled",
      title: "Canceled",
      icon: "ban",
      color: "#fc0328",
      href: "#/manage/6/0/0",
    },
    {
      key: 7,
      filter: "waiting",
      title: "Waiting",
      icon: "hourglass-half",
      color: "#f5a142",
      href: "#/manage/7/0/0",
    },
  ];
  const filters_map = { all: 0, received: 1, archived: 2, complete: 3, rejected: 4, sent: 5, cancelled: 6, waiting: 7 };

  const columns = [
    { title: "#", dataIndex: "index", key: "key", width: 30 },
    {
      field: "Filename",
      dataIndex: "name",
      key: "subject",
      width: 300,
      render: (name) => <div style={{ wordWrap: "break-word", wordBreak: "break-word" }}>{name}</div>,
    },
    {
      field: "From",
      dataIndex: "sender",
      key: "from",
      render: (sender) => <span>{sender.kdss_name ?? ""}</span>,
    },
    {
      field: "Status",
      dataIndex: "",
      key: "status",
      width: 150,
      render: (per) => {
        let key = per.status.toLowerCase();
        let active = key === "waiting" ? { ...filters[1], title: "waiting" } : filters[filters_map[key]];
        let title = active?.title;
        let icon = { icon: active?.icon, color: active?.color };

        if (per.waiting_for_userid && per.waiting_for_userid === user?.kdss_user) {
          title = "ACT NOW";
          icon.icon = "clipboard-check";
          icon.color = "#46a642";
        }

        if (per.status === "PROCESSING") {
          title = "In progress";
          icon.icon = "spinner";
          icon.color = "orange";
        }

        return (
          <div className="status_container">
            <FontAwesomeIcon icon={["fas", icon.icon]} color={icon.color} />
            &nbsp;&nbsp;
            <span style={{ textTransform: "capitalize" }}>{title}</span>
          </div>
        );
      },
    },
    {
      field: "Lastchange",
      dataIndex: "modified_dt",
      key: "modified_dt",
      width: 160,
      render: (per) => {
        return <DateTime value={per} />;
      },
      sorter: (a, b) => {
        let d1 = new Date(a).getTime();
        let d2 = new Date(b).getTime();
        return d1 >= d2 ? 1 : -1;
      },
    },
    {
      field: "Action",
      key: "action",
      width: 100,
      render: (per) => {
        const items = [
          {
            label: (
              <div
                onClick={() => {
                  setStore("txin", per.txnid);
                  history.push(`/manage/${filter}/preview/${per.docid}`);
                }}>
                Preview
              </div>
            ),
            key: "preview",
          },
          {
            label: <a href={`#/manage/${filter}/share/${per.docid}`}>Share</a>,
            key: "share",
          },
          {
            label: (
              <a href={`#/manage/${filter}/download/${per.docid}`} onClick={() => setStore("filename", per)}>
                Download
              </a>
            ),
            key: "download",
          },
          ...(user?.kdss_user === per.sent_by_userid && per.status === "WAITING"
            ? [
                {
                  label: (
                    <div
                      onClick={() => {
                        setSelectedId(per.docid);
                        setVisible(true);
                      }}>
                      Cancel
                    </div>
                  ),
                  key: "cancel",
                },
              ]
            : []),
        ];

        return (
          <Dropdown trigger="click" menu={{ items }}>
            <Button type="primary">Action</Button>
          </Dropdown>
        );
      },
    },
  ];

  const {
    data = { list: [], total: 0 },
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["get_doc_list", filter, page, sortDir, user.kdss_user],
    queryFn: async () => {
      let json = {
        with_count: 0,
        page: page - 1,
        pper: 8,
        status: filters[filter].filter,
        sort: "modified_dt",
        sort_by: sortDir,
        namefilter: encodeURIComponent(namefilter),
      };
      const { success, data } = await axios.post("/client/api/doc/list", json);
      if (success) {
        const list = data.list.map((e, i) => {
          return { ...e, key: i };
        });
        return { list, total: data.doccount };
      }
    },
    staleTime: false,
  });

  const handleSearch = (e) => {
    e.preventDefault();
    refetch();
  };

  return (
    <div className="manage_router_container">
      <Loading loading={isFetching} />
      <div className="absfull">
        <div className="home_filter_container">
          {Object.keys(docCounts)?.map((key) => (
            <Filter key={key} count={docCounts[key]} dataKey={key} activeFilter={filter} />
          ))}
        </div>
        <div className="home_filter_table">
          <form onSubmit={handleSearch}>
            <div
              style={{
                display: "flex",
                width: "100%",
                paddingBottom: "10px",
              }}>
              <Input placeholder={Translate[ln].Manage.Search.Placeholder} onChange={(e) => setNamefilter(`${e.target.value}`.trim())} />
              <Button onClick={refetch} loading={isFetching}>
                {Translate[ln].Manage.Search.Button}
              </Button>
            </div>
            <Table
              bordered
              size="small"
              pagination={{
                current: page,
                pageSize: 8,
                total: data.total,
                showSizeChanger: false,
                onChange: (page) => setPage(page),
              }}
              loading={isFetching}
              dataSource={data.list}
              onChange={(_, __, c) => setSortDir(c.order || "descend")}
              columns={columns.map((e) => ({
                ...e,
                title: e.title || Translate[ln].Manage.Table[e.field],
              }))}
            />
          </form>
        </div>
      </div>
      {visible && (
        <CancelModal
          visible={visible}
          closeModal={() => {
            setVisible(false);
            setSelectedId(null);
          }}
          id={selectedId}
        />
      )}
    </div>
  );
};

export default ManageRouter;
